'use client';

import BlazeSlider from 'blaze-slider';
import 'blaze-slider/dist/blaze.css';
import { useEffect, useRef } from 'react';
import Link from 'next/link';
import Image from 'next/image';

export default function ExpertReviewsSlider({ reviews, count, componentID }) {
  const sliderRef = useRef(null);
  const sliderInstanceRef = useRef(null);

  useEffect(() => {
    if (!sliderRef.current || sliderInstanceRef.current) return;

    sliderInstanceRef.current = new BlazeSlider(sliderRef.current, {
      all: {
        transitionDuration: 600,
        slidesToShow: 1
      }
    });

    return () => {
      // destroy() doesn't actually reset the slides fully so even after this,
      // the last seen slide will be remembered, and pagination resets as if it's
      // the first slide. Accepting since it's a loop and doesn't look like a bug.
      sliderInstanceRef.current?.destroy();
      sliderInstanceRef.current = null;
    };
  }, []);

  return (
    <div className="blaze-slider" ref={sliderRef}>
      <div className="blaze-container">
        <div className="blaze-track-container mx-auto flex max-w-200 justify-center">
          {count > 1 && (
            <button className="blaze-prev mt-21.25 ml-5 hidden h-4.5 w-4.5 bg-white sm:block">
              <span className="sr-only">previous</span>
            </button>
          )}
          <div className="blaze-track relative max-w-full lg:max-w-180">
            {reviews.map((review, index) => {
              return (
                <div key={index}>
                  <div
                    className={`mx-auto max-w-lg text-center sm:px-4 ${count > 1 ? '' : 'pb-4'}`}
                  >
                    {review?.link?.href && review?.logo?.url ? (
                      <Link
                        href={review.link.href}
                        title={review.link.title || 'Review author'}
                        prefetch={false}
                      >
                        <Image
                          id={componentID + '_' + review.logo.uid}
                          src={`${review.logo.url}?disable=upscale`}
                          alt={review.logo.title.replace(/\.[^/.]+$/, '')}
                          width={review.logo.dimension.width}
                          height={review.logo.dimension.height}
                          sizes="241px"
                          style={{ width: '241px', height: 'auto' }}
                          className="mx-auto mb-4 min-h-12 min-w-60.25"
                        />
                      </Link>
                    ) : (
                      <Image
                        id={componentID + '_' + review.logo.uid}
                        src={`${review.logo.url}?disable=upscale`}
                        alt={review.logo.title.replace(/\.[^/.]+$/, '')}
                        width={review.logo.dimension.width}
                        height={review.logo.dimension.height}
                        sizes="241px"
                        style={{ width: '241px', height: 'auto' }}
                        className="mx-auto mb-4 min-h-12 min-w-60.25"
                      />
                    )}
                    {review.review_content && (
                      <p className="body-r sm:body-l">
                        {review.review_content}
                      </p>
                    )}
                    {review.author && (
                      <p className="body-r sm:body-l pt-4 pb-2">
                        {review.author}
                      </p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          {count > 1 && (
            <button className="blaze-next mt-21.25 mr-5 hidden h-4.5 w-4.5 bg-white sm:block">
              <span className="sr-only">next</span>
            </button>
          )}
        </div>
        {count > 1 && (
          <div className="blaze-pagination indicators-light mx-auto mt-4 flex h-4 text-center"></div>
        )}
      </div>
    </div>
  );
}
